import { Injectable } from '@angular/core';
import { printClassName } from '@orgbrain/lib-data';
import FingerprintJS, { Agent, GetResult } from '@fingerprintjs/fingerprintjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private fpPromise: Promise<Agent>;
  private cachedResult: GetResult | null = null;

  constructor() {
    printClassName(' ---> ', this);
    // Initialize FingerprintJS agent at service creation
    this.fpPromise = FingerprintJS.load();
  }

  async getFingerprint(): Promise<number> {
    if (this.cachedResult) {
      return this.hashVisitorId(this.cachedResult.visitorId);
    }
    const fp = await this.fpPromise;
    this.cachedResult = await fp.get();
    return this.hashVisitorId(this.cachedResult.visitorId);
  }

  /**
   * Converts FingerprintJS visitorId (string) to a numeric hash
   * to maintain compatibility with existing backend which expects a number
   */
  private hashVisitorId(visitorId: string): number {
    let hash = 0;
    for (let i = 0; i < visitorId.length; i++) {
      const char = visitorId.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32-bit integer
    }
    return Math.abs(hash);
  }

  getDeviceName(): string {
    const nav = navigator as any;
    const ua = navigator.userAgent;

    // Parse OS
    let os = 'Unknown OS';
    let osVersion = '';
    if (ua.includes('Windows NT 10')) {
      os = 'Windows';
      osVersion = '10';
    } else if (ua.includes('Windows NT 6.3')) {
      os = 'Windows';
      osVersion = '8.1';
    } else if (ua.includes('Windows NT 6.2')) {
      os = 'Windows';
      osVersion = '8';
    } else if (ua.includes('Windows NT 6.1')) {
      os = 'Windows';
      osVersion = '7';
    } else if (ua.includes('Mac OS X')) {
      os = 'Mac OS';
      const match = ua.match(/Mac OS X (\d+[._]\d+[._]?\d*)/);
      osVersion = match ? match[1].replace(/_/g, '.') : '';
    } else if (ua.includes('Linux')) {
      os = 'Linux';
    } else if (ua.includes('Android')) {
      os = 'Android';
      const match = ua.match(/Android (\d+\.?\d*)/);
      osVersion = match ? match[1] : '';
    } else if (ua.includes('iPhone') || ua.includes('iPad')) {
      os = 'iOS';
      const match = ua.match(/OS (\d+[._]\d+)/);
      osVersion = match ? match[1].replace(/_/g, '.') : '';
    }

    // Parse Browser
    let browser = 'Unknown Browser';
    let browserVersion = '';
    if (ua.includes('Edg/')) {
      browser = 'Edge';
      const match = ua.match(/Edg\/(\d+\.?\d*)/);
      browserVersion = match ? match[1] : '';
    } else if (ua.includes('Chrome/') && !ua.includes('Edg/')) {
      browser = 'Chrome';
      const match = ua.match(/Chrome\/(\d+\.?\d*)/);
      browserVersion = match ? match[1] : '';
    } else if (ua.includes('Safari/') && !ua.includes('Chrome/')) {
      browser = 'Safari';
      const match = ua.match(/Version\/(\d+\.?\d*)/);
      browserVersion = match ? match[1] : '';
    } else if (ua.includes('Firefox/')) {
      browser = 'Firefox';
      const match = ua.match(/Firefox\/(\d+\.?\d*)/);
      browserVersion = match ? match[1] : '';
    }

    // Get resolution
    const resolution = `${window.screen.width}x${window.screen.height}`;

    return `${os}/${osVersion} ${browser}/${browserVersion} ${resolution}`;
  }

  getIsMac(): boolean {
    const platform = (navigator as any).userAgentData?.platform || navigator.platform || '';
    return platform.toLowerCase().includes('mac');
  }
}
